import React, {useCallback} from 'react'
import {useIntl} from 'react-intl'

type Props = {
  onChoice: (choice: boolean) => void
  noBackdrop?: boolean
}

const TranscriptionModal: React.FC<Props> = ({onChoice, noBackdrop = false}) => {
  const intl = useIntl()

  const yes = useCallback(() => onChoice(true), [onChoice])
  const no = useCallback(() => onChoice(false), [onChoice])

  const title = intl.formatMessage({id: 'TRANSCRIPTION.MODAL.TITLE'})
  const yesLabel = intl.formatMessage({id: 'TRANSCRIPTION.MODAL.YES'})
  const noLabel = intl.formatMessage({id: 'TRANSCRIPTION.MODAL.NO'})
  const yesTooltip = intl.formatMessage({
    id: 'TRANSCRIPTION.MODAL.YES_TOOLTIP',
  })
  const noTooltip = intl.formatMessage({id: 'TRANSCRIPTION.MODAL.NO_TOOLTIP'})

  if (noBackdrop) {
    return (
      <div
        className='aichoice-content no-backdrop'
        role='dialog'
        aria-modal='false'
        aria-label={title}
      >
        <div className='aichoice-title'>{title}</div>
        <div className='aichoice-actions'>
          <button className='yes' onClick={yes} aria-label={yesTooltip} data-tooltip={yesTooltip}>
            {yesLabel}
          </button>
          <button className='no' onClick={no} aria-label={noTooltip} data-tooltip={noTooltip}>
            {noLabel}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className='aichoice-backdrop' role='dialog' aria-modal='true' aria-label={title}>
      <div className='aichoice-modal'>
        <div className='aichoice-title'>{title}</div>
        <div className='aichoice-actions'>
          <button className='yes' onClick={yes} aria-label={yesTooltip} data-tooltip={yesTooltip}>
            {yesLabel}
          </button>
          <button className='no' onClick={no} aria-label={noTooltip} data-tooltip={noTooltip}>
            {noLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(TranscriptionModal)
